/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalServiceVo
 */
export interface AdditionalServiceVo {
    /**
     * 附加服务id
     * @type {number}
     * @memberof AdditionalServiceVo
     */
    additionalServiceId?: number;
    /**
     * 附加服务名称
     * @type {string}
     * @memberof AdditionalServiceVo
     */
    additionalServiceName?: string;
    /**
     * 附加服务金额
     * @type {number}
     * @memberof AdditionalServiceVo
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof AdditionalServiceVo
     */
    code?: string;
}

/**
 * Check if a given object implements the AdditionalServiceVo interface.
 */
export function instanceOfAdditionalServiceVo(value: object): value is AdditionalServiceVo {
    return true;
}

export function AdditionalServiceVoFromJSON(json: any): AdditionalServiceVo {
    return AdditionalServiceVoFromJSONTyped(json, false);
}

export function AdditionalServiceVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalServiceVo {
    if (json == null) {
        return json;
    }
    return {
        
        'additionalServiceId': json['additionalServiceId'] == null ? undefined : json['additionalServiceId'],
        'additionalServiceName': json['additionalServiceName'] == null ? undefined : json['additionalServiceName'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'code': json['code'] == null ? undefined : json['code'],
    };
}

export function AdditionalServiceVoToJSON(json: any): AdditionalServiceVo {
    return AdditionalServiceVoToJSONTyped(json, false);
}

export function AdditionalServiceVoToJSONTyped(value?: AdditionalServiceVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'additionalServiceId': value['additionalServiceId'],
        'additionalServiceName': value['additionalServiceName'],
        'amount': value['amount'],
        'code': value['code'],
    };
}

